/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateOrderStakeholderCommandResult } from '../../models/create-order-stakeholder-command-result';

export interface ApiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain$Params {
      body?: {
'Name'?: string;
'StackholderId'?: number;
'UnitId'?: number;
}
}

export function apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOrderStakeholderCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateOrderStakeholderCommandResult>;
    })
  );
}

apiNurseryManagerOrderStakeholderCreateOrderStakeholderPost$Plain.PATH = '/api/NurseryManager/OrderStakeholder/CreateOrderStakeholder';
